var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-now-time-line",style:(_vm.nowTimePosition)},[_c('div',{staticClass:"triangle"}),_c('div',{staticClass:"line",style:(_vm.lineWidth)})])}
var staticRenderFns = []

export { render, staticRenderFns }